import { render } from "./equality-report-gender-position-salary.vue?vue&type=template&id=4ff5f061"
import script from "./equality-report-gender-position-salary.vue?vue&type=script&lang=js"
export * from "./equality-report-gender-position-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/equality/equality-report-gender-position-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ff5f061"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ff5f061', __exports__)) {
    api.reload('4ff5f061', __exports__)
  }
  
  module.hot.accept("./equality-report-gender-position-salary.vue?vue&type=template&id=4ff5f061", () => {
    api.rerender('4ff5f061', render)
  })

}


export default __exports__